export default "__VITE_ASSET__BUm8i2Ga__"